import { Action, handleActions } from 'redux-actions'
import { call, put, takeLatest } from 'redux-saga/effects'

import { fetchMGMCode } from '@/api/PromotionApi'
import { STATUS_CODE } from '@/domains/CommonDomain'
import { IMgmInquireResponse } from '@/domains/InviteDomain'
import { loadingActions } from '@/modules/common/loading'
import { createFetchAction } from '@/utils/actionUtils'
import { ApiError } from '@/utils/errorUtils'
import { apiSuccessReducer } from '@/utils/reducerUtils'

/* type */
export const MGM = 'mgm'
export const MGM_INQUIRY = `${MGM}/inquiry`

/* state */
export interface IMgmState extends IMgmInquireResponse {
  errorMessage: string
}

const initialState: IMgmState = {
  referralCode: '',
  promoUrl: '',
  promoFriendUrl: '',
  errorMessage: '',
}

/* selector */
export const mgmSelector = {}

/* action */
export const mgmCodeAsync = createFetchAction(MGM_INQUIRY)

/* reducer */
export const reducer = {
  [mgmCodeAsync.SUCCESS]: apiSuccessReducer,
  [mgmCodeAsync.FAILURE]: (state: IMgmState, action: Action<ApiError<any>>) => ({
    ...state,
    errorMessage:
      action.payload.code === STATUS_CODE.CUSTOMER_ALLOWED ? '' : action.payload.message,
  }),
}
export const mgmReducer = handleActions(reducer, initialState)

/* worker saga */
function* getMgmCode() {
  try {
    yield put(loadingActions.start(MGM))
    const response: IMgmInquireResponse = yield call(fetchMGMCode)
    if (response.referralCode) {
      yield put(mgmCodeAsync.success(response))
    }
  } catch (e) {
    yield put(mgmCodeAsync.failure(e))
  } finally {
    yield put(loadingActions.finish(MGM))
  }
}

/* watcher saga */
export const mgmSaga = [takeLatest(mgmCodeAsync.FETCH, getMgmCode)]
